module.exports = __webpack_public_path__ + "img/vps.022d5cd.svg";